import React from 'react'
import '../styles/activeCallList-filter'

class SearchText extends React.Component {
    render() {
        const { className, filter, onChange } = this.props

        return (
            <div className="search-text">
                <input type="text" className="form-control" placeholder="Search..." value={filter} onChange={(e) => onChange(e.target.value)} />
            </div>
        )
    }
}

export default SearchText



// WEBPACK FOOTER //
// ./components/SearchText.jsx